export default (state, action) => {
    switch (action.type) {
        case "user":
            return {...state, ...action.payload};
        default:
            return state;
    }
}